import Screen, { type ScreenProps } from 'ui/layouts/Screen';
import ProfileComponent from 'ui/organizms/Profile';

const Profile = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Profile'
    >
        <ProfileComponent />
    </Screen>
);

export default Profile;